export default __webpack_public_path__ + "static/Wechatcode-7cc9c2fcfdf9a69a95059f5263b3c0c8.jpg";